module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"message_sent":"Отправлено сообщение","mail":"Письмо","sms":"SMS"}}')
  delete Component.options._Ctor
}
